'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionsWrapperStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = function style(_ref) {
  var themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);

  var _theme$reactackle$com = theme.reactackle.components.alertsArea.item.actions,
      itemSpacingX = _theme$reactackle$com.itemSpacingX,
      itemSpacingY = _theme$reactackle$com.itemSpacingY;


  return (0, _styledComponents.css)(['margin:-', ' -', ';& > *{margin:', ' ', ';}'], (0, _reactackleCore.getValueString)(itemSpacingY), (0, _reactackleCore.getValueString)(itemSpacingX), (0, _reactackleCore.getValueString)(itemSpacingY), (0, _reactackleCore.getValueString)(itemSpacingX));
};

var ActionsWrapperStyled = exports.ActionsWrapperStyled = _styledComponents2.default.div.withConfig({
  displayName: 'ActionsWrapperStyled'
})(['flex-shrink:0;flex-grow:1;text-align:right;', ''], style);


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-alert-area/dist/Alert/styles/ActionsWrapperStyled.js
// module id = 516
// module chunks = 0